// extracted by mini-css-extract-plugin
export default {"imageWrapper":"pE-z","hovered":"qE-z","hoverImage":"rE-z","mainImage":"sE-z","imageNoBackground":"tE-z","fullSizeImage":"uE-z"};